import { getStorageItem, setStorageItem, memoryReloadGames } from '../lib'

// 🔴 A GAME IS WON ONLY WITH FEWER THAN THREE MISTAKES (George, 22 September 2026: "if they
// make 3 mistakes, its not considered a win"). Three is the limit — and the player MAY KEEP
// GOING, because he also said "they can continue to 6, then 9, etc.": the tally simply keeps
// counting past three, but the win is already gone when it is reached.
export const MISTAKE_LIMIT = 3

// 'win' | 'lose' | null. The null is the BLANK the saved list shows for a puzzle that is not
// finished — there is no result to record yet, so nothing is written for it.
export const gameOutcome = ({ percent, mistakeCount }) => {
  if (percent !== 100) return null
  return (mistakeCount || 0) < MISTAKE_LIMIT ? 'win' : 'lose'
}

export const returnGamesFromStorage = () => {
  const games = getStorageItem('games') || []
  games.map(game => {
    const storedGame = returnGameFromStorage(game.gameId)
    const { percent, progressType } = returnGameProgress(storedGame || { puzzle: [] })
    game.percent = percent
    game.progressType = progressType
    game.difficulty = storedGame && storedGame.difficulty ? storedGame.difficulty : null
    // 🔴 MISTAKES ARE TRACKED PER GAME and the saved list reads them from here, so the count
    // and the recorded result can never drift from the game they belong to.
    game.mistakeCount = storedGame && storedGame.mistakeCount ? storedGame.mistakeCount : 0
    game.outcome = gameOutcome(game)
    return game
  })
  return games
}

export const returnGameFromStorage = gameId => getStorageItem(`gameId_${gameId}`)

export const addGameToStorage = game => {
  const games = returnGamesFromStorage()

  const { gameId, createdAt } = game

  games.unshift({ key: gameId, gameId, createdAt })

  setStorageItem('games', games)

  setStorageItem(`gameId_${gameId}`, game)
}

export const removeGameFromStorage = gameId => {
  const games = returnGamesFromStorage()

  setStorageItem('games', games.filter(i => i.gameId !== gameId))

  setStorageItem(`gameId_${gameId}`)
}

export const updateGameToStorage = (gameId, puzzle, puzzleFormatted, hints) => {
  const updatedAt = new Date()

  const storedGame = returnGameFromStorage(gameId)

  const games = returnGamesFromStorage()
  const gamesIndex = games.findIndex(i => i.key === gameId)

  games[gamesIndex] = { ...games[gamesIndex], puzzle, puzzleFormatted, hints, updatedAt }

  const update = { ...storedGame, puzzle, puzzleFormatted, hints, updatedAt }

  setStorageItem('games', games)
  setStorageItem(`gameId_${gameId}`, update)
  memoryReloadGames(true)
}

export const returnGameProgress = ({ puzzle }) => {
  const percent = parseInt(puzzle.filter(i => i !== null).length / puzzle.length * 100)
  const solved = Boolean(percent === 100)
  const progressType = solved ? 'circle' : 'line'
  return { percent, progressType }
}

// Patch one game's stored metadata WITHOUT touching its board — used to bank the mistake
// tally at the moment a digit is rejected, which is a moment no placement happens at.
export const updateGameMeta = (gameId, patch) => {
  const storedGame = returnGameFromStorage(gameId)
  if (!storedGame) return

  const updatedAt = new Date()

  const games = returnGamesFromStorage()
  const gamesIndex = games.findIndex(i => i.key === gameId)
  if (gamesIndex !== -1) games[gamesIndex] = { ...games[gamesIndex], ...patch, updatedAt }

  setStorageItem('games', games)
  setStorageItem(`gameId_${gameId}`, { ...storedGame, ...patch, updatedAt })
  memoryReloadGames(true)
}
